// packages import
import { Maybe } from 'graphql/jsutils/Maybe'
import { FC } from 'react'

// component imports
import ClientDropdown from '../../common/ClientDropdown'

// others
import { ExternalUser } from '../../../../generated'

interface ClientFilterProps {
  clientId: string
  setReportFilters: React.Dispatch<React.SetStateAction<Record<string, any>>>
}

const ClientFilter: FC<ClientFilterProps> = ({ clientId, setReportFilters }) => {
  const handleClientChange = (value: Maybe<ExternalUser>) => {
    setReportFilters((prev: any) => ({ ...prev, clientId: value?.id }))
  }

  return (
    <ClientDropdown selectedClientId={clientId} label="Client" sx={{ minWidth: 200 }} onChange={handleClientChange} />
  )
}

export default ClientFilter
